import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';

import tick from '../assets/img/tick.svg';

class SuccessDownload extends Component {
  constructor(props) {
    super(props)

    this.state = {

    }
  }

  render() {
    const { t } = this.props;
    return (
      <div className="successCard">
        <img src={tick} alt="tick" />
        <h2>{t("success.title")}</h2>
        <p>{t("success.desc")}</p>
      </div>
    )
  }
}

export default withTranslation()(SuccessDownload)
